import axios from 'axios'
import { host } from './host'

export const axiosInstance = axios.create({
    baseURL: `${host}`,
})
